import { createContext, useContext } from 'react'
import { FlightsClassTypes } from 'constants/flight'

interface MaldivesDirectBundleContextValue {
  charterBundle: boolean
  isPricePerPerson: boolean
  fareClass: FlightsClassTypes
  duration?: number
}

const MaldivesDirectBundleContext = createContext<MaldivesDirectBundleContextValue>({
  charterBundle: false,
  isPricePerPerson: true,
  fareClass: FlightsClassTypes.ECONOMY,
  duration: undefined,
})

export const MaldivesDirectBundleProvider = MaldivesDirectBundleContext.Provider

export function useMaldivesDirectBundleContext(): MaldivesDirectBundleContextValue {
  return useContext(MaldivesDirectBundleContext)
}
